<div class="referral-help-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="icon-wrapper">
      <mat-icon>link</mat-icon>
    </div>
    <div class="header-text">
      <h2>Referral URL Feature</h2>
      <p>How referrals are tracked and attributed</p>
    </div>
  </div>

  <p class="intro-text">
    Generate a unique referral link to refer new hosts or sales agents. 
    When someone registers through your link, they can be automatically attributed to you.
  </p>

  <!-- Steps -->
  <div class="steps">
    <div class="step">
      <div class="step-number">1</div>
      <div class="step-content">
        <h3>Create &amp; Share Your Link</h3>
        <p>Generate a referral URL from your dashboard and share it with potential users.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-number">2</div>
      <div class="step-content">
        <h3>Cookie is Set on Click</h3>
        <p>When a user clicks your link, they are taken to the registration page and a cookie containing your agent ID is set in their browser <strong>(expires in 30 days)</strong>.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-number">3</div>
      <div class="step-content">
        <h3>Registration Creates the Connection</h3>
        <p>If the user registers while the cookie is still active, your agent ID is permanently saved to their account in the database.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-number">4</div>
      <div class="step-content">
        <h3>Automatic Attribution</h3>
        <p>Once linked, your agent ID will be automatically applied when the user creates properties or signs up as a sales agent.</p>
      </div>
    </div>
  </div>

  <!-- Quick Reference -->
  <div class="section">
    <h3 class="section-title">Quick Reference</h3>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Action</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>User clicks your referral link</td>
            <td>Cookie set (30-day expiry)</td>
          </tr>
          <tr>
            <td>User registers with active cookie</td>
            <td class="success">Permanent referral relationship created</td>
          </tr>
          <tr>
            <td>User creates properties or becomes an agent</td>
            <td class="success">Your agent ID is automatically applied</td>
          </tr>
          <tr>
            <td>Cookie is cleared or expires before registration</td>
            <td class="warning">No automatic attribution</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Warning -->
  <div class="warning-box">
    <div class="warning-icon">
      <mat-icon>warning_amber</mat-icon>
    </div>
    <div class="warning-text">
      <strong>Important</strong>
      <p>
        Referral tracking depends on the browser cookie. If the user clears their cookies, 
        uses a different browser/device, or registers after the cookie expires, the referral 
        will <strong>not</strong> be automatically applied.
      </p>
    </div>
  </div>

  <p class="footer-note">
    This system is designed to give you credit for referrals while being transparent about its limitations.
  </p>
</div>

<!-- Dialog Actions -->
<div class="dialog-actions">
  <button mat-button mat-dialog-close>Close</button>
</div>